export default __webpack_public_path__ + "static/media/landing.ddac92b3.jpg";